import { css } from "@emotion/css"

const Step = ({ children, current }: { children: string; current: string }) => {
  const ariaCurrent = children === current ? "step" : undefined

  return (
    <div className={style} aria-current={ariaCurrent}>
      {children}
    </div>
  )
}

export default Step

const style = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 104px;
  height: 30px;
  background-color: #e5e5e5;
  border-radius: 6px;
  &[aria-current="step"] {
    color: white;
    background-color: #00ad7a;
  }
`
